import { render, staticRenderFns } from "./MailReader.vue?vue&type=template&id=b5d5b004&scoped=true"
import script from "./MailReader.vue?vue&type=script&lang=js"
export * from "./MailReader.vue?vue&type=script&lang=js"
import style0 from "./MailReader.vue?vue&type=style&index=0&id=b5d5b004&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5d5b004",
  null
  
)

export default component.exports